/* eslint-disable react/react-in-jsx-scope */
import Banner from '../../shared/banners/banner'
import ContactoBanner from '../../shared/contactBanner/contacto-banner'
import banner_soporteOperaciones from '../../../assets/images/soporteOperaciones/banner.jpg'
import ListaOperaciones from './listaOperaciones'
import DescripcionOperaciones from './descripcionOperaciones'

const SoporteOperaciones = (): any => {
  return (
    <div className='w-full h-full flex flex-col justify-center items-center'>
      <div className='relative'>
        <div className='sticky top-0 pt-[0.1px]'>
          <Banner
            image={banner_soporteOperaciones}
            title="Optimiza tus Operaciones Digitales"
          />
        </div>
        <div className='sticky top-0 bg-white flex flex-col justify-center items-center'>
          <DescripcionOperaciones />
          <ListaOperaciones/>
          <ContactoBanner />
        </div>
      </div>
    </div>
  )
}
export default SoporteOperaciones
